import { createAction } from 'redux-act';
// report-common
import { getReportActions } from '../../report-common';
//////////////////////////////////////////////////

const {
  setReports,
  selectItem,
  setReportType,
  setUsedReport,
  setListLoading,
  setFilterProps,
  setInitialState,
  setReportPending,
  setTableTitleSort,
  getItemListRequest,
  getItemListSuccess,
  createReportRequest,
  updateReportRequest,
  setTableTitleFilter,
  setIgnorePromptStatus,
  resetListAndPagination,
  exportReportDataRequest,
  setInitialStateOmitReport,
  changeDefaultReportRequest,
  getAvailableReportsRequest,
} = getReportActions();

const setTruckGuid = createAction('setTruckGuid');
const setDriverGuid = createAction('setDriverGuid');
const getTruckListSuccess = createAction('getTruckListSuccess');
const updateTollChargeSuccess = createAction('updateTollChargeSuccess');
const assignDriverTruckRequest = createAction('assignDriverTruckRequest');
const receivedDriverListSuccess = createAction('receivedDriverListSuccess');
const visitTollChargesOnFleetPage = createAction('visitTollChargesOnFleetPage');
const setAdditionalSearchCriteria = createAction('setAdditionalSearchCriteria');
const updateTruckTollChargeRequest = createAction('updateTruckTollChargeRequest');
const updateDriverTollChargeRequest = createAction('updateDriverTollChargeRequest');

export {
  // report
  setReports,
  selectItem,
  setReportType,
  setUsedReport,
  setListLoading,
  setFilterProps,
  setInitialState,
  setReportPending,
  setTableTitleSort,
  getItemListRequest,
  getItemListSuccess,
  createReportRequest,
  updateReportRequest,
  setTableTitleFilter,
  setIgnorePromptStatus,
  resetListAndPagination,
  exportReportDataRequest,
  setInitialStateOmitReport,
  changeDefaultReportRequest,
  getAvailableReportsRequest,
  // report
  setTruckGuid,
  setDriverGuid,
  getTruckListSuccess,
  updateTollChargeSuccess,
  assignDriverTruckRequest,
  receivedDriverListSuccess,
  setAdditionalSearchCriteria,
  visitTollChargesOnFleetPage,
  updateTruckTollChargeRequest,
  updateDriverTollChargeRequest,
};
